import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "button"];

  connect() {
    this.buttonTarget.addEventListener("click", this.toggle.bind(this));
  }

  toggle() {
    const input = this.inputTarget;

    if (input.type === "password") {
      input.type = "text";
    } else {
      input.type = "password";
    }
  }
}
